<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerIconRetina from "leaflet/dist/images/marker-icon-2x.png";
import { mapGetters } from 'vuex';

export default {
  name: "PartnerZone",
  props: {
    latitude: {
      type: Number,
      default: null,
    },
    longitude: {
      type: Number,
      default: null,
    },
    radius: {
      type: Number,
      default: 50,
    },
    companyName: {
      type: String,
      default: null,
    },
  },
  watch: {
    radius(newRadius) {
      if (this.currentCircle) {
        this.updateCircleRadius(newRadius);
      }
    },
    latitude () {
      if (this.latitude && this.longitude) {
        this.addCircle([this.latitude, this.longitude]);

      }
    },
    longitude () {
      if (this.longitude && this.latitude) {
        this.addCircle([this.latitude, this.longitude]);
      }
    },

    coords (){
      if(this.coords != null &&  this.coords.latitude != null  && this.coords.longitude != null ){
        this.showUserOnMap()
      }
    }
  },
  data() {
    return {
      map: null,
      currentMarker: null,

      defaultIcon: L.icon({
        iconUrl: markerIcon,
        iconRetinaUrl: markerIconRetina,
        shadowUrl: markerShadow,
        iconSize: [20, 31],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [10, 10],
      }),
    };
  },

  mounted() {
    if(this.latitude == null || this.longitude == null){
       this.$store.dispatch('location/fetchLocation');
      }

    this.initializeMap();

  },

  computed:{
       ...mapGetters('location', ['coords', 'coordsError', 'locationLoading'])
  },

  methods: {



    initializeMap() {

      var lat = this.latitude ;
      var lng = this.longitude ;

      if (this.latitude == null || this.longitude  == null  ){
        lat = 34.7471872 ;
        lng = 10.7577344 ;
      }

      this.map = L.map("mi_mapa_pzc").setView([lat, lng], 16);

      const osmLayer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          minZoom:6,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      });

      const worldImagery = L.tileLayer(
        'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
          maxZoom: 19,
          attribution: 'Imagery &copy; <a href="https://www.esri.com/">Esri</a>'
        }
      );

      const referenceLayer = L.tileLayer(
        'https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}', {
          maxZoom: 19,
          attribution: 'Labels & boundaries &copy; <a href="https://www.esri.com/">Esri</a>'
        }
      );

      const transport = L.tileLayer(
        'https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}',
        { maxZoom: 19, attribution: 'Esri Transportation…' }
      );


      const satelliteWithLabels = L.layerGroup([worldImagery, referenceLayer, transport ]);

      if(!this.fromMenu){
        this.map.on('click', this.handleMapClick);
      }

      satelliteWithLabels.addTo(this.map);

      const baseLayers = {
          "Standard": osmLayer,
          "Satellite": satelliteWithLabels
      };

      L.control.layers(baseLayers).addTo(this.map);


      this.map.on("click", this.handleMapClick);

      if (this.latitude && this.longitude) {
        this.addMarker([this.latitude, this.longitude]);
        this.addCircle([this.latitude, this.longitude]);
      }

  },


    updateCircleRadius(newRadius) {
      if (this.currentCircle) {
        this.currentCircle.setRadius(newRadius);
      }
    },

    addCircle(position) {
      if (this.currentCircle) {
          this.map.removeLayer(this.currentCircle);
      }

      this.currentCircle = L.circle(position, {
          color: 'blue',
          fillColor: 'blue',
          fillOpacity: 0.2,
          radius: this.radius ? this.radius : 0
      }).addTo(this.map);
    },

    getLocation(){
      this.$store.dispatch('location/fetchLocation');
    },

    showUserOnMap() {
      if (!this.coords) return;
      this.$emit("position-selected", this.coords);
      this.map.setView([this.coords.latitude, this.coords.longitude], 16);
      this.addMarker([this.coords.latitude, this.coords.longitude]);
    },

    addMarker(position) {
      if (this.currentMarker) {
        this.map.removeLayer(this.currentMarker);
      }

      this.currentMarker = L.marker(position, { icon: this.defaultIcon })
        .addTo(this.map)
        .bindPopup(
          this.companyName
            ? `${this.companyName} <br/> ${position[0].toFixed(
                5
              )}, ${position[1].toFixed(5)}`
            : `${position[0].toFixed(5)}, ${position[1].toFixed(5)}`
        )
        .openPopup();
    },

    handleMapClick(event) {
      const { lat, lng } = event.latlng;
      this.$store.commit('location/SET_LOCATION', {
        latitude: lat,
        longitude: lng
      });
      this.addMarker([lat, lng]);
      this.$emit("position-selected", this.coords);
    },
  },
};
</script>

<template>
  <div>
    <div id="mi_mapa_pzc" style="cursor: crosshair;"></div>

    <div v-if="locationLoading" class="text-center text-muted mt-2">
      Localisation en cours... 
    </div>

    <div v-if="coordsError"  class="text-center text-danger mt-2">
      {{ this.coordsError ? 'Une erreur est survenue. Veuillez réessayer.' : 'Veuillez activer la localisation sur votre appareil pour utiliser cette fonctionnalité.' }}
      <span @click="getLocation()" style="cursor:pointer; margin-left:5px;">
        <img width="15px" class="mr-1" src="@/assets/icons/refresh.svg" style="cursor: pointer;" />
      </span>
    </div>
  </div>
</template>

<style>
#mi_mapa_pzc {
  width: 100%;
  height: 450px;
  min-height: 200px;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
